// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"9c6ed9d0","56":"84b9de88","58":"9c6ed9d0","225":"9c6ed9d0","396":"9c6ed9d0","506":"9c6ed9d0","679":"9c6ed9d0","926":"8932b7f5","930":"9c6ed9d0","984":"49df54b2"}[chunkId] + ".css";
};